var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('div',{staticClass:"row"},[_c('app-navigation'),_c('main',{staticClass:"col"},[_c('div',{staticClass:"p-4"},[_c('router-view')],1)])],1),_c('v-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }